export type Action =
    | AppAction
    | ListAction
    | MessageAction
    | RoomAction
    | SearchAction
    | SettingsAction
    | UserAction
    | ChatAction

export const enum AppAction {
    RESUME_SOCKET_CONNECTION = 'RESUME_SOCKET_CONNECTION',
    PAUSE_SOCKET_CONNECTION = 'PAUSE_SOCKET_CONNECTION',
    PUBLISH_WEBCAM = 'PUBLISH_WEBCAM',
    BROWSER_RELOAD = 'BROWSER_RELOAD',
    SET_DARK_MODE = 'SET_DARK_MODE',
    FULL_WINDOW = 'FULL_WINDOW',
}

export const enum AppStateType {
    ALERTS = 'alerts',
    APP = 'app',
    AUTHENTICATION = 'authentication',
    MYWEBCAM = 'myWebcam',
    SESSION = 'session',
    TIP_DEFAULTS = 'tipDefaults',
    TOKENS = 'tokens',
}

export const enum ChatCommandEvent {
    GENERATE_COMMANDS = 'GENERATE_COMMANDS',
}

export const enum ConfirmationType {
    Friend,
    Bookmark,
}

// moved from /utilities/mfcLogic/ueopts.ts (to avoid circular dependency)
export const enum DisplayUeopt {
    text = 'text',
    /** avatar */
    default = 'default',
    preview = 'preview',
    detailed = 'detailed',
}

export enum PMPlaySoundOnUeopt {
    allMessages = 'txrx',
    receivedMessage = 'rx',
    onlyOnFirstMessage = 'on_first',
    none = 'none',
}

export const enum DisplayModeFriends {
    list = 'list',
    /** avatar */
    default = 'default',
    preview = 'preview',
    detailed = 'detailed',
}

export const enum EMOJI_ANCHOR_LOCATIONS {
    top = 'top', // default
    bottom = 'bottom', // used for Drawers
}

export const enum EventAction {
    APP = 'APP',
    LISTS = 'LISTS',
    MESSAGE = 'MESSAGE',
    ROOM = 'ROOM',
    SEARCH = 'SEARCH',
    UPDATE_SETTINGS = 'UPDATE_SETTINGS',
    USERS = 'USERS',
    ARCHIVE = 'ARCHIVE',
}

export const enum EventType {
    PARTICIPANTS = 'PARTICIPANTS',
    ACTIONS = 'ACTIONS',
    APP = 'APP',
    FCS = 'FCS',
    HEALTH = 'HEALTH',
    INDEX = 'INDEX',
    LISTS = 'LISTS',
    PING = 'PING',
    PONG = 'PONG',
    READY = 'READY',
    // READY_FOR_DATA = 'READY_FOR_DATA',
    SEARCH = 'SEARCH',
    SERVER_SIDE_USER = 'SERVER_SIDE_USER',
    SETTINGS = 'SETTINGS',
    USERS = 'USERS',
    FCTYPE_LOGIN = 'FCTYPE_LOGIN',
    CHAT = 'CHAT',
}

export const enum ExploreCategory {
    Popular = 'Popular',
    Trending = 'Trending',
    MissMFC = 'MissMFC',
    NewModels = 'NewModels',
    GroupShows = 'GroupShows',
}

export const enum GridLocation {
    Home = 'home',
    Search = 'search',
    Room = 'room',
    Friends = 'friends',
}

export const enum HEALTH {
    DISCONNECTED = 'DISCONNECTED',
    CONNECTING = 'CONNECTING',
    CONNECTED = 'CONNECTED',
    ERROR = 'CANT_CONNECT',
    PAUSED = 'PAUSED',
    // ACTIVE = 'ACTIVE',
    // INACTIVE = 'INACTIVE',
    // INITIALIZING = 'INITIALIZING',
    // NEEDS_RELOAD = 'NEEDS_RELOAD',
    // RECONNECTING = 'RECONNECTING',
    // RECONNECT_CANCELLED = 'RECONNECT_CANCELLED',
    // RECONNECT_MANUAL = 'RECONNECT_MANUAL',
    // STARTING = 'STARTING',
    // RESTARTING = 'RESTARTING',
}

export const enum LayoutEvent {
    CHANGE = 'CHANGE',
    LAYOUT_CHANGE = 'LAYOUT_CHANGE',
    PORTAL_CHANGE = 'PORTAL_CHANGE',
    PORTAL_DIMENSIONS_CHANGE = 'PORTAL_DIMENSIONS_CHANGE',
}

export const enum ListAction {
    SUBSCRIBE_UPDATES = 'SUBSCRIBE_UPDATES',
    UNSUBSCRIBE_UPDATES = 'UNSUBSCRIBE_UPDATES',
    DELETE = 'DELETE',
    INSERT = 'INSERT',
    MODIFY = 'MODIFY',
    REMOVE = 'REMOVE',
    RESET = 'RESET',
}

export const enum ChatAction {
    ARCHIVE = 'ARCHIVE',
}

export const enum ListType {
    ALERTS = 'ALERTS',
    BOOKMARKED_FRIENDS_BROADCASTING = 'BOOKMARKED_FRIENDS_BROADCASTING',
    BOOKMARKED_FRIENDS_OFFLINE = 'BOOKMARKED_FRIENDS_OFFLINE',
    BOOKMARKED_FRIENDS_ONLINE = 'BOOKMARKED_FRIENDS_ONLINE',
    BOOKMARKED_FRIENDS_ONLINE_NOT_BROADCASTING = 'BOOKMARKED_FRIENDS_ONLINE_NOT_BROADCASTING',
    BOOKMARKS = 'BOOKMARKS',
    BOOKMARKS_BROADCASTING = 'BOOKMARKS_BROADCASTING',
    BOOKMARKS_OFFLINE = 'BOOKMARKS_OFFLINE',
    BOOKMARKS_ONLINE = 'BOOKMARKS_ONLINE',
    BOOKMARKS_ONLINE_NOT_BROADCASTING = 'BOOKMARKS_ONLINE_NOT_BROADCASTING',
    DEFAULT = 'DEFAULT',
    DEFAULT_PUBLIC = 'DEFAULT_PUBLIC',
    FRIENDS = 'FRIENDS',
    LAST_VIEWED = 'LAST_VIEWED',
    MEMBER_FRIENDS_OFFLINE = 'MEMBER_FRIENDS_OFFLINE',
    MEMBER_FRIENDS_ONLINE = 'MEMBER_FRIENDS_ONLINE',
    MISSMFC = 'MISSMFC',
    MISSMFC_ONLINE = 'MISSMFC_ONLINE',
    MODEL_FRIENDS = 'MODEL_FRIENDS',
    MODEL_FRIENDS_BROADCASTING = 'MODEL_FRIENDS_BROADCASTING',
    MODEL_FRIENDS_OFFLINE = 'MODEL_FRIENDS_OFFLINE',
    MODEL_FRIENDS_ONLINE = 'MODEL_FRIENDS_ONLINE',
    MODEL_FRIENDS_ONLINE_NOT_BROADCASTING = 'MODEL_FRIENDS_ONLINE_NOT_BROADCASTING',
    NEWMODELS = 'NEWMODELS',
    POPULAR = 'POPULAR',
    PREMIUM_OR_MODEL_FRIENDS = 'PREMIUM_OR_MODEL_FRIENDS',
    SEARCH = 'SEARCH',
    MODEL_TRENDING = 'MODEL_TRENDING',
    MODEL_GROUP_SHOWS = 'MODEL_GROUP_SHOWS',
    PINNED_MODEL_TRENDING = 'PINNED_MODEL_TRENDING',
    PINNED_MODEL_POPULAR = 'PINNED_MODEL_POPULAR',
    PINNED_MODEL_MISS_MFC = 'PINNED_MODEL_MISS_MFC',
    PINNED_MODEL_RECENTLY_VISITED = 'PINNED_MODEL_RECENTLY_VISITED',
    LATEST_PM_TIMESTAMP = 'LATEST_PM_TIMESTAMP',
    LATEST_PM_UNREAD = 'LATEST_PM_UNREAD',
}

export const enum MessageAction {
    LOAD_PMS_USER_LIST = 'LOAD_PMS_USER_LIST',
    LOAD_PMS = 'LOAD_PMS',
    SEND_MESSAGE = 'SEND_MESSAGE',
    SEND_TYPING_INDICATOR = 'SEND_TYPING_INDICATOR',
    VIDEO_FEED = 'VIDEO_FEED',
    CLEAR_UNREAD_COUNT = 'CLEAR_UNREAD_COUNT',
    RESUME_UNREAD_COUNT = 'RESUME_UNREAD_COUNT',
    PAUSE_UNREAD_COUNT = 'PAUSE_UNREAD_COUNT',
    LOAD_PM_PREVIEW = 'LOAD_PM_PREVIEW',
    HIDE = 'HIDE',
}

export const enum MessageEvent {
    ACTIVE_MESSAGE = 'ACTIVE_MESSAGE',
    LIST = 'LIST',
    LOADING = 'LOADING',
    MESSAGE = 'message',
    MESSAGES = 'messages',
    SEARCH = 'search',
}

export const enum RoomAction {
    CLUBSHOW_INFO = 'CLUBSHOW_INFO',
    // END_SESSION = 'END_SESSION',
    FORGET_ROOM = 'FORGET_ROOM',
    REGISTER_ROOM = 'REGISTER_ROOM',
    REQUEST_GROUP = 'REQUEST_GROUP',
    REQUEST_PRIVATE = 'REQUEST_PRIVATE',
    REQUEST_VOYEUR = 'REQUEST_VOYEUR',
    SEND_MESSAGE = 'SEND_MESSAGE',
    SEND_XMESG = 'SEND_XMESG',
    SUBSCRIBE = 'SUBSCRIBE',
    STREAM_PUBLIC_SHOW = 'STREAM_PUBLIC_SHOW',
    STREAM_CLUBSHOW = 'STREAM_CLUBSHOW',
    UNSUBSCRIBE = 'UNSUBSCRIBE',
    // UNSUBSCRIBE_CLUBSHOW = 'UNSUBSCRIBE_CLUBSHOW',
    SWAP = 'SWAP',
}

export const enum RoomEvent {
    RESTORED = 'RESTORED',
    PIN_ROOM = 'PIN_ROOM',
    PIN_HELPER_ID = 'PIN_HELPER_ID',
}

export const enum SearchAction {
    SEARCH = 'SEARCH',
    SEARCH_LIST = 'SEARCH_LIST',
}

export const enum SearchEvent {
    /** set/update the search session state */
    UPDATE_HISTORY = 'UPDATE_HISTORY',
    /** get the list filter results back from worker */
    RESULTS_LIST = 'RESULTS_LIST',
    /** set/update the search query state */
    UPDATE_QUERY = 'UPDATE_QUERY',
    /** send the list query to the worker to compute */
    QUERY_LIST = 'QUERY_LIST',
    // /** set/update the search referrer state */
    // REFERRER = 'REFERRER',
    /** get the results back from worker */
    RESULTS = 'RESULTS',
    /** set/update search loading state */
    LOADING = 'LOADING',
    /** send the query to the worker to compute */
    QUERY = 'QUERY',
}

export const enum SecureStateType {
    AGE_VERIFICATION = 'ageVerification',
}

export const enum SettingsAction {
    UPDATE = 'UPDATE',
}

export const enum SettingsEvent {
    SAVE = 'SAVE',
}

export const enum SettingsType {
    DEFAULT = 'DEFAULT',
    MY_ACCOUNT = 'MY_ACCOUNT',
    MY_WEBCAM = 'MY_WEBCAM',
    NEWS_NOTIFICATIONS = 'NEWS_NOTIFICATIONS',
    PRIVACY = 'PRIVACY',
    ROOM = 'ROOM',
}

export const enum SortOrder {
    ASC = 'asc',
    DESC = 'desc',
}

export const enum UserAction {
    GET_ALL_USERS = 'GET_ALL_USERS',
    ADD_BOOKMARK = 'ADD_BOOKMARK',
    ADD_FRIEND = 'ADD_FRIEND',
    ADD_IGNORE = 'ADD_IGNORE',
    ADD_NOTE = 'ADD_NOTE',
    CHANGES = 'CHANGES',
    DELETE_NOTE = 'DELETE_NOTE',
    HIDE_USER = 'HIDE_USER',
    LOAD_EXTRAS = 'LOAD_EXTRAS',
    LOAD_SOCIAL_MEDIA = 'LOAD_SOCIAL_MEDIA',
    LOOKUP_USER = 'LOOKUP_USER',
    REMOVE_BOOKMARK = 'REMOVE_BOOKMARK',
    REMOVE_FRIEND = 'REMOVE_FRIEND',
    REMOVE_IGNORE = 'REMOVE_IGNORE',
    SAVE_NOTE = 'SAVE_NOTE',
    SEARCH_NOTES = 'SEARCH_NOTES',
    SOCKET_LOOKUP_USER = 'SOCKET_LOOKUP_USER',
    UNHIDE_USER = 'UNHIDE_USER',
    SUBSCRIBE_UPDATES = 'SUBSCRIBE_UPDATES',
    UNSUBSCRIBE_UPDATES = 'UNSUBSCRIBE_UPDATES',
    SUBSCRIBE_ALERTS = 'SUBSCRIBE_ALERTS',
    UNSUBSCRIBE_ALERTS = 'UNSUBSCRIBE_ALERTS',
    ALERTS = 'ALERTS',
    RECOVER_FROM_KICK = 'RECOVER_FROM_KICK',
    // SET_MODELS_YOU_MAY_LIKE_TARGET = 'SET_MODELS_YOU_MAY_LIKE_TARGET',
    MESSAGES = 'MESSAGES',
    SET_MODELS_REQUESTED = 'SET_MODELS_REQUESTED',
    SET_MODELS_LOADED = 'SET_MODELS_LOADED',
}

export const enum UserEvent {
    ADD_NOTE = 'ADD_NOTE',
    BROADCASTING = 'BROADCASTING',
    DELETE_NOTE = 'DELETE_NOTE',
    LOAD_EXTRAS = 'LOAD_EXTRAS',
    LOOKUP = 'LOOKUP',
    SAVE_NOTE = 'SAVE_NOTE',
    SEARCH_NOTES = 'SEARCH_NOTES',
    SOCKET_LOOKUP = 'SOCKET_LOOKUP',
    UPDATE = 'UPDATE',
    ALL_USERS = 'ALL_USERS',
    MODELS_REQUESTED = 'MODELS_REQUESTED',
    MODELS_LOADED = 'MODELS_LOADED',
    ME_ID = 'ME_ID',
    ME_GUEST = 'ME_GUEST',
}

export const enum VideoEvent {
    DIMENSIONS = 'dimensions',
    INITIALIZING = 'initializing',
    PLAYING = 'playing',
    SNAP = 'snap',
}

// ordered by override priority
export const enum VideoType {
    ModelTile,
    FloatingPreview,
    StickyPreview,
    PinnedRoom,
    PinnedPm,
    Room,
    Menu,
}
